import { PreloadableRouteObject, TFileToRouteMap } from '~/app/models'
import { getRoutesFromMap } from '~/app/utils/lazy'
import { EClientPath } from '~/models/api'

export const authRoutesFileToRouteMap: TFileToRouteMap = {
  loginPage: {
    path: EClientPath.login,
    getImportPromise: () => import('~/pages/login'),
  },
  registerPage: {
    path: EClientPath.register,
    getImportPromise: () => import('~/pages/register'),
  },
  forgotPasswordPage: {
    path: EClientPath.forgotPassword,
    getImportPromise: () => import('~/pages/forgotPassword'),
  },
}

const authRoutes: PreloadableRouteObject[] = getRoutesFromMap(
  authRoutesFileToRouteMap,
)

export default authRoutes
